import React, { BaseSyntheticEvent } from 'react';
//
import colors from 'theme/colors';

interface Props {
  fill: string;
  size?: number;
  onClick?: (e: BaseSyntheticEvent) => void;
}

const plotSize = 30;

const BoxPlotIcon = ({ fill = colors.globalIcon, size = plotSize, onClick }: Props) => (
  <svg width={size} height={size} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
    <rect x="0.5" y="0.5" width="19" height="15" rx="1.5" stroke={fill} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5C6.44772 5 6 5.44772 6 6V7.5H4.04297V7C4.04297 6.72386 3.81911 6.5 3.54297 6.5C3.26683 6.5 3.04297 6.72386 3.04297 7V8V9C3.04297 9.27614 3.26683 9.5 3.54297 9.5C3.81911 9.5 4.04297 9.27614 4.04297 9V8.5H6V10C6 10.5523 6.44772 11 7 11H13C13.5523 11 14 10.5523 14 10V8.5H16.0454V9C16.0454 9.27614 16.2693 9.5 16.5454 9.5C16.8216 9.5 17.0454 9.27614 17.0454 9V7C17.0454 6.72386 16.8216 6.5 16.5454 6.5C16.2693 6.5 16.0454 6.72386 16.0454 7V7.5H14V6C14 5.44772 13.5523 5 13 5H7Z"
      fill={fill}
    />
  </svg>
);

export default BoxPlotIcon;
